import ufeApi from 'services/api/ufeApi';

export function accountClosureCheck(profileId) {
    const url = `/gway/v2/users/profiles/${profileId}/accountClosureCheck`;

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default { accountClosureCheck };
